export type SearchSectionType = 'PROGRAM' | 'PROGRAM_SERIES' | 'VOD_ASSET' | 'VOD_SERIES';

export const DEFAULT_TYPE_MAP: Record<string, SearchSectionType> = {
    'Videolaenutuse filmid': 'VOD_ASSET',
    'Huub Series': 'VOD_SERIES',
    'Huub Movies': 'VOD_ASSET',
    'TV seriaalid': 'VOD_SERIES',
    'Filmid telekanalitelt': 'PROGRAM',
    'Laste seriaalid': 'PROGRAM_SERIES',
    'Kids Movies': 'VOD_ASSET',
};

export interface SearchResultItem {
    id?: string;
    type?: string;
    title?: string;
    image_url?: string;
    rank?: number;
    item?: {
        id: string;
        title: string;
        image_url?: string;
        category?: string;
        description?: string;
        background_image_url?: string;
        genres?: string[];
        tagline?: string;
        [key: string]: any;
    };
    [key: string]: any;
}

export interface SearchCustomAttributes {
    variant?: string;
    variety?: string;
    module_type?: string;
    [key: string]: any;
}

export interface SearchOrderOption {
    id: string;
    title: string;
    [key: string]: any;
}

export interface SearchData {
    count?: number;
    custom_attributes?: SearchCustomAttributes;
    id?: string;
    image_aspect_ratio?: string;
    order?: string;
    order_options?: SearchOrderOption[];
    pages?: number;
    results: SearchResultItem[];
    searchable?: boolean;
    title?: string;
    [key: string]: any;
}

export type SearchDatasArray = SearchData[];

export interface TypedsearchData {
    type: string;
    response: SearchData;
}

export interface SearchDisplayItem {
    id: string;
    titleId: string;
    type: 'program' | 'movie' | 'series';
    category: string;
    title: string;
    image: string;
    channelId?: string;
}

export const EMPTY_SEARCH_RESULT: SearchData = {
    results: [],
};
